import { AgentAdminFormComponent } from './pages-private/agent/agent-admin/agent-admin-form/agent-admin-form.component';
import { DynamicEntityViewComponent } from './pages-private/dynamic-entity/dynamic-entity-view/dynamic-entity-view.component';
import { forwardRef, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgxGaugeModule } from 'ngx-gauge';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { AppComponent } from './app.component';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './pages-public/login/login.component';
import { MainLayoutComponent } from './pages-private/main-layout/main-layout.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbDropdownModule, NgbCollapseModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule, NzSubmenuNoneInlineChildComponent } from 'ng-zorro-antd/menu';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { BlockedComponent } from './pages-public/login/modes/blocked/blocked.component';
import { SuspendedComponent } from './pages-public/login/modes/suspended/suspended.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { AccessControlComponent } from './components/access-control/access-control.component';
import { HasPermissionDirective } from './components/has-permission.directive';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { FocusDirective } from './components/focus.directive';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { HighchartsChartComponent, provideHighcharts } from 'highcharts-angular';
import { LoginFormComponent } from './pages-public/login/modes/login-form/login-form.component';
import { ForgotPasswordFormComponent } from './pages-public/login/modes/forgot-password-form/forgot-password-form.component';
import { HomeComponent } from './pages-private/home/home.component';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { DynamicEntityListComponent } from './pages-private/dynamic-entity/dynamic-entity-list/dynamic-entity-list.component';
import { DynamicEntityModalComponent } from './pages-private/dynamic-entity/dynamic-entity-modal/dynamic-entity-modal.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { DftSingleColumnComponent } from './components/dynamic-form/templates/dft-single-column/dft-single-column.component';
import { DftDualColumnComponent } from './components/dynamic-form/templates/dft-dual-column/dft-dual-column.component';
import { AgentAdminListComponent } from './pages-private/agent/agent-admin/agent-admin-list/agent-admin-list.component';
import { AgentFaoListComponent } from './pages-private/agent/agent-fao/agent-fao-list/agent-fao-list.component';
import { AgentFaoFormComponent } from './pages-private/agent/agent-fao/agent-fao-form/agent-fao-form.component';
import { AgentUnderwriterListComponent } from './pages-private/agent/agent-underwriter/agent-underwriter-list/agent-underwriter-list.component';
import { AgentUnderwriterFormComponent } from './pages-private/agent/agent-underwriter/agent-underwriter-form/agent-underwriter-form.component';
import { MemberListComponent } from './pages-private/member/member-list/member-list.component';
import { MemberFormComponent } from './pages-private/member/member-form/member-form.component';
import { DynamicEntityFieldSelectorComponent } from './pages-private/dynamic-entity/dynamic-entity-field-selector/dynamic-entity-field-selector.component';
import { PendingChangesGuard } from './components/pending-changes.guard';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { DynamicFormInputTextComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-text/dynamic-form-input-text.component';
import { DynamicFormInputNumberComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-number/dynamic-form-input-number.component';
import { DynamicFormInputDropDownComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-drop-down/dynamic-form-input-drop-down.component';
import { DynamicFormInputBooleanComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-boolean/dynamic-form-input-boolean.component';
import { DynamicFormInputDateComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-date/dynamic-form-input-date.component';
import { DynamicFormInputTimeComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-time/dynamic-form-input-time.component';
import { DynamicFormInputDatetimeComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-datetime/dynamic-form-input-datetime.component';
import { DynamicFormInputFileComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-file/dynamic-form-input-file.component';
import { DynamicFormInputPasswordComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-password/dynamic-form-input-password.component';
import { DynamicFormInputEmailComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-email/dynamic-form-input-email.component';
import { DynamicFormInputMsisdnComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-msisdn/dynamic-form-input-msisdn.component';
import { DynamicFormInputSubDynamicComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-sub-dynamic/dynamic-form-input-sub-dynamic.component';
import { WorkflowListComponent } from './pages-private/workflow/workflow-list/workflow-list.component';
import { WorkflowFormComponent } from './pages-private/workflow/workflow-form/workflow-form.component';
import { WorkflowFormStepComponent } from './pages-private/workflow/workflow-form/components/workflow-form-step/workflow-form-step.component';
import { WorkflowFormSectionComponent } from './pages-private/workflow/workflow-form/components/workflow-form-section/workflow-form-section.component';
import { WorkflowFormElementComponent } from './pages-private/workflow/workflow-form/components/workflow-form-element/workflow-form-element.component';
import { WorkflowFormButtonComponent } from './pages-private/workflow/workflow-form/components/workflow-form-button/workflow-form-button.component';
import { WorkflowFormActionComponent } from './pages-private/workflow/workflow-form/components/workflow-form-action/workflow-form-action.component';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { InvalidFormIndicatorComponent } from './pages-private/workflow/workflow-form/components/invalid-form-indicator/invalid-form-indicator.component';
import { DynamicFormInputTextareaComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-textarea/dynamic-form-input-textarea.component';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { InvalidFormDrawerComponent } from './pages-private/workflow/workflow-form/components/invalid-form-drawer/invalid-form-drawer.component';
import { TicketMemberSearchComponent } from './pages-private/tickets/ticket-member-search/ticket-member-search.component';
import { DftCardComponent } from './components/dynamic-form/templates/dft-card/dft-card.component';
import { ComposeNotificationComponent } from './components/compose-notification/compose-notification.component';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { EmailBodyEditorComponent } from './components/email-body-editor/email-body-editor.component';
import { EmployerListComponent } from './pages-private/employer/employer-list/employer-list.component';
import { EmployerFormComponent } from './pages-private/employer/employer-form/employer-form.component';
import { CategoryListComponent } from './pages-private/category/category-list/category-list.component';
import { CategoryFormComponent } from './pages-private/category/category-form/category-form.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { TicketReportListComponent } from './pages-private/tickets/ticket-report/ticket-report-list/ticket-report-list.component';
import { TicketReportFormComponent } from './pages-private/tickets/ticket-report/ticket-report-form/ticket-report-form.component';
import { TicketReportReportComponent } from './pages-private/tickets/ticket-report/ticket-report-report/ticket-report-report.component';
import { MemberBulkUploadComponent } from './pages-private/member/member-bulk-upload/member-bulk-upload.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RoleListComponent } from './pages-private/role/role-list/role-list.component';
import { RoleEditComponent } from './pages-private/role/role-edit/role-edit.component';
import { PermissionComponent } from './pages-private/permission/permission.component';
import { WorkflowRoleListComponent } from './pages-private/workflow/workflow-role-list/workflow-role-list.component';
import { WorkflowRoleEditComponent } from './pages-private/workflow/workflow-role-edit/workflow-role-edit.component';
import { MemberViewComponent } from './pages-private/member/member-view/member-view.component';
import { MemberViewDetailsComponent } from './pages-private/member/member-view/components/member-view-details/member-view-details.component';
import { MemberViewMembershipsComponent } from './pages-private/member/member-view/components/member-view-memberships/member-view-memberships.component';
import { NzSpaceComponent } from "ng-zorro-antd/space";
import { MemberBulkUploadListComponent } from './pages-private/member/member-bulk-upload-list/member-bulk-upload-list.component';
import { MemberBulkUploadFormComponent } from './pages-private/member/member-bulk-upload-form/member-bulk-upload-form.component';
import { MemberBulkUploadViewComponent } from './pages-private/member/member-bulk-upload-view/member-bulk-upload-view.component';
import { TicketReportFormSimpleModalComponent } from './pages-private/tickets/ticket-report/ticket-report-form-simple-modal/ticket-report-form-simple-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TicketReportRunModalComponent } from './pages-private/tickets/ticket-report/ticket-report-run-modal/ticket-report-run-modal.component';
import { WithoutPermissionDirective } from './components/without-permission.directive';
import { TicketReportFormSubColumnModalComponent } from './pages-private/tickets/ticket-report/ticket-report-form-sub-column-modal/ticket-report-form-sub-column-modal.component';
import { TicketListComponent } from './pages-private/tickets/ticket-list/ticket-list.component';
import { TicketFormComponent } from './pages-private/tickets/tickets-form/ticket-form.component';
import { TicketFormSectionImagesComponent } from './pages-private/tickets/tickets-form/components/ticket-form-section-images/ticket-form-section-images.component';
import { TicketCommunicationModalComponent } from './pages-private/tickets/tickets-form/components/ticket-communication-modal/ticket-communication-modal.component';
import { TicketAdditionalCommentComponent } from './pages-private/tickets/tickets-form/components/ticket-additional-comment/ticket-additional-comment.component';
import { TicketHistoryComponent } from './pages-private/tickets/tickets-form/components/ticket-history/ticket-history.component';
import { MemberViewClaimsComponent } from './pages-private/member/member-view/components/member-view-claims/member-view-claims.component';
import { TicketAssignModalComponent } from './pages-private/tickets/tickets-assign-modal/ticket-assign-modal.component';
import { TicketDashboardComponent } from './pages-private/tickets/ticket-dashboard/ticket-dashboard.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { AwsQuicksiteComponent } from './components/aws-quicksite/aws-quicksite.component';
import { DashboardTotalComponent } from './pages-private/dashboard/dashboard-total/dashboard-total.component';

import { CommunicationSendComponent } from './pages-private/communication/send/communication-send.component';
import { CommunicationScheduledAutomatedComponent } from './pages-private/communication/scheduled-automated/communication-scheduled-automated.component';
import { CommunicationLogComponent } from './pages-private/communication/log/communication-log.component';
import { RecipientFilterModalComponent } from './pages-private/communication/send/recipient-filter-modal/recipient-filter-modal.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CloseOutline } from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';
import { ScheduleModalComponent } from './pages-private/communication/send/schedule-modal/schedule-modal.component';
import { CommunicationConfirmationModalComponent } from './pages-private/communication/send/confirmation-modal/communication-confirmation-modal.component';
import { FilterInfoComponent } from './pages-private/communication/filter-info/filter-info.component';
import { ScheduleInfoComponent } from './pages-private/communication/schedule-info/schedule-info.component';
import { CommunicationReportComponent } from './pages-private/communication/report/communication-report.component';
import { TicketDuplicateWarningModalComponent } from './pages-private/tickets/tickets-form/components/ticket-duplicate-warning-modal/ticket-duplicate-warning-modal.component';
import { NzFloatButtonModule } from 'ng-zorro-antd/float-button';
import { AiChatWidgetComponent } from './components/ai-chat-widget/ai-chat-widget.component';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { AgentAdminViewComponent } from './pages-private/agent/agent-admin/agent-admin-view/agent-admin-view.component';
import { AgentViewClaimsComponent } from './pages-private/agent/agent-admin/agent-admin-view/components/agent-view-tickets/agent-view-tickets.component';
import { AgentViewDetailsComponent } from './pages-private/agent/agent-admin/agent-admin-view/components/agent-view-details/agent-view-details.component';
import { AgentAdminViewAppRolesComponent } from './pages-private/agent/agent-admin/agent-admin-view/components/agent-admin-view-app-roles/agent-admin-view-app-roles.component';
import { AgentAdminViewTicketRolesComponent } from './pages-private/agent/agent-admin/agent-admin-view/components/agent-admin-view-ticket-roles/agent-admin-view-ticket-roles.component';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { HierarchyInputComponent } from './components/hierarchy-input/hierarchy-input.component';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { DynamicFormInputHierarchyComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-hierarchy/dynamic-form-input-hierarchy.component';
registerLocaleData(en);
const routes: Routes = [
	// { path: 'home', component: TicketDashboardComponent },
	// { path: 'home', component: HomeComponent},
	// { path: 'home', component: HomeComponent },

	{ path: 'dashboard/total', component: DashboardTotalComponent },

	{ path: 'dynamic/list', component: DynamicEntityListComponent },
	{ path: 'dynamic/:id', component: DynamicEntityViewComponent, canDeactivate: [PendingChangesGuard] },
	{ path: 'workflow/list', component: WorkflowListComponent },
	{ path: 'workflow/new', component: WorkflowFormComponent, canDeactivate: [PendingChangesGuard] },
	{ path: 'workflow/:id', component: WorkflowFormComponent, canDeactivate: [PendingChangesGuard] },

	{ path: 'workflow_role/list', component: WorkflowRoleListComponent },
	{ path: 'workflow_role/new', component: WorkflowRoleEditComponent },
	{ path: 'workflow_role/:workflowRoleId/edit', component: WorkflowRoleEditComponent },

	{ path: 'agent/admin/list', component: AgentAdminListComponent },
	{ path: 'agent/admin/new', component: AgentAdminFormComponent },
	{ path: 'agent/admin/:id/edit', component: AgentAdminFormComponent },
	{ path: 'agent/admin/:agentId/view', component: AgentAdminViewComponent },
	{ path: 'agent/fao/list', component: AgentFaoListComponent },
	{ path: 'agent/fao/new', component: AgentFaoFormComponent },
	{ path: 'agent/fao/:id/edit', component: AgentFaoFormComponent },
	{ path: 'agent/underwriter/list', component: AgentUnderwriterListComponent },
	{ path: 'agent/underwriter/new', component: AgentUnderwriterFormComponent },
	{ path: 'agent/underwriter/:id/edit', component: AgentUnderwriterFormComponent },

	{ path: 'member/list', component: MemberListComponent },
	{ path: 'member/new', component: MemberFormComponent },
	{ path: 'member/:memberId/edit', component: MemberFormComponent },
	{ path: 'member/:memberId/view', component: MemberViewComponent },
	{ path: 'member/bulk/list', component: MemberBulkUploadListComponent },
	{ path: 'member/bulk/new', component: MemberBulkUploadFormComponent },
	{ path: 'member/bulk/:id/view', component: MemberBulkUploadViewComponent },

	{ path: 'category/list', component: CategoryListComponent },
	{ path: 'category/new', component: CategoryFormComponent },
	{ path: 'category/:id/edit', component: CategoryFormComponent },
	{ path: 'employer/list', component: EmployerListComponent },
	{ path: 'employer/new', component: EmployerFormComponent },
	{ path: 'employer/:id/edit', component: EmployerFormComponent },


	{ path: 'ticket/report/list', component: TicketReportListComponent },
	{ path: 'ticket/report/:workflowId/list', component: TicketReportListComponent },
	{ path: 'ticket/report/:workflowId/new', component: TicketReportFormComponent },
	{ path: 'ticket/report/:reportId/edit', component: TicketReportFormComponent },
	{ path: 'ticket/report/:reportId/report', component: TicketReportReportComponent },

	{ path: 'ticket/:ticketMode/member-search', component: TicketMemberSearchComponent },

	{ path: 'ticket/:ticketMode/dashboard', component: TicketDashboardComponent },
	{ path: 'ticket/:ticketMode/list', component: TicketListComponent },
	{ path: 'ticket/:ticketMode/:workflowId/list', component: TicketListComponent },
	{ path: 'ticket/:ticketMode/:workflowId/:stepId/list', component: TicketListComponent },

	{ path: 'ticket/:ticketMode/:workflowId/member/:memberId', component: TicketFormComponent },
	{ path: 'ticket/:ticketMode/:workflowId/member/:memberId/:categories', component: TicketFormComponent },
	{ path: 'ticket/:ticketMode/:workflowId/dependent/:dependentId', component: TicketFormComponent },
	{ path: 'ticket/:ticketMode/:ticketId', component: TicketFormComponent },

	{ path: 'communication/send', component: CommunicationSendComponent },
	{ path: 'communication/send/:id', component: CommunicationSendComponent },
	{ path: 'communication/scheduled-automated', component: CommunicationScheduledAutomatedComponent },
	{ path: 'communication/log', component: CommunicationLogComponent },
	{ path: 'communication/report/:id', component: CommunicationReportComponent },

	{ path: 'permissions', component: PermissionComponent },
	{ path: 'role/list', component: RoleListComponent },
	{ path: 'role/new', component: RoleEditComponent },
	{ path: 'role/:roleId/edit', component: RoleEditComponent },

	{ path: '**', redirectTo: '/dashboard/total' }];

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		MainLayoutComponent,
		BlockedComponent,
		SuspendedComponent,
		AccessControlComponent,
		HasPermissionDirective,
		WithoutPermissionDirective,
		FocusDirective,
		LoginFormComponent,
		ForgotPasswordFormComponent,
		HomeComponent,
		DynamicEntityListComponent,
		DynamicEntityViewComponent,
		DynamicEntityModalComponent,
		DynamicFormComponent,
		DftSingleColumnComponent,
		DftDualColumnComponent,
		AgentAdminListComponent,
		AgentAdminFormComponent,
		AgentFaoListComponent,
		AgentFaoFormComponent,
		AgentUnderwriterListComponent,
		AgentUnderwriterFormComponent,
		MemberListComponent,
		MemberFormComponent,
		DynamicEntityFieldSelectorComponent,
		DynamicFormInputTextComponent,
		DynamicFormInputNumberComponent,
		DynamicFormInputDropDownComponent,
		DynamicFormInputBooleanComponent,
		DynamicFormInputDateComponent,
		DynamicFormInputTimeComponent,
		DynamicFormInputDatetimeComponent,
		DynamicFormInputFileComponent,
		DynamicFormInputPasswordComponent,
		DynamicFormInputEmailComponent,
		DynamicFormInputMsisdnComponent,
		DynamicFormInputSubDynamicComponent,
		WorkflowListComponent,
		WorkflowFormComponent,
		WorkflowFormStepComponent,
		WorkflowFormSectionComponent,
		WorkflowFormElementComponent,
		WorkflowFormButtonComponent,
		WorkflowFormActionComponent,
		InvalidFormIndicatorComponent,
		DynamicFormInputTextareaComponent,
		TicketListComponent,
		InvalidFormDrawerComponent,
		TicketMemberSearchComponent,
		TicketFormComponent,
		DftCardComponent,
		ComposeNotificationComponent,
		EmployerListComponent,
		EmployerFormComponent,
		CategoryListComponent,
		CategoryFormComponent,
		TicketFormSectionImagesComponent,
		TicketCommunicationModalComponent,
		TicketReportListComponent,
		TicketReportFormComponent,
		TicketReportReportComponent,
		TicketAdditionalCommentComponent,
		CommunicationSendComponent,
		CommunicationScheduledAutomatedComponent,
		CommunicationLogComponent,
		CommunicationReportComponent,
		RecipientFilterModalComponent,
		ScheduleModalComponent,
		FilterInfoComponent,
		ScheduleInfoComponent,
		CommunicationConfirmationModalComponent,
		MemberBulkUploadComponent,
		TicketHistoryComponent,
		RoleListComponent,
		RoleEditComponent,
		PermissionComponent,
		WorkflowRoleListComponent,
		WorkflowRoleEditComponent,
		MemberViewComponent,
		MemberViewDetailsComponent,
		MemberViewMembershipsComponent,
		MemberViewClaimsComponent,
		MemberBulkUploadListComponent,
		MemberBulkUploadFormComponent,
		MemberBulkUploadViewComponent,
		TicketReportFormSimpleModalComponent,
		TicketReportRunModalComponent,
		TicketAssignModalComponent,
		TicketReportFormSubColumnModalComponent,
		TicketDashboardComponent,
		AwsQuicksiteComponent,
		MemberBulkUploadListComponent,
		MemberBulkUploadFormComponent,
		MemberBulkUploadViewComponent,
		DashboardTotalComponent,
		TicketDuplicateWarningModalComponent,
		AiChatWidgetComponent,
		AgentAdminViewComponent,
		AgentViewClaimsComponent,
		AgentViewDetailsComponent,
		AgentAdminViewAppRolesComponent,
		AgentAdminViewTicketRolesComponent,
  HierarchyInputComponent,
  DynamicFormInputHierarchyComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		NgbModule,
		RouterModule.forRoot(routes, { useHash: false }),
		FontAwesomeModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		NgbDropdownModule,
		NgbCollapseModule,
		NgbProgressbarModule,
		NgbDatepickerModule,
		NgxChartsModule,
		IconsProviderModule,
		NzLayoutModule,
		NzMenuModule,
		NzTableModule,
		NzTabsModule,
		NzTagModule,
		NzBreadCrumbModule,
		NzUploadModule,
		NzProgressModule,
		NzMessageModule,
		NzInputModule,
		NzCardModule,
		NzDescriptionsModule,
		NzEmptyModule,
		NzTimelineModule,
		NzRadioModule,
		HighchartsChartComponent,
		NgxGaugeModule,
		NzPageHeaderModule,
		NzFormModule,
		NzSelectModule,
		NzModalModule,
		NzDividerModule,
		NzCheckboxModule,
		NzButtonModule,
		NzToolTipModule,
		NzDatePickerModule,
		NzBadgeModule,
		NzCollapseModule,
		NzStepsModule,
		NzGridModule,
		NzSwitchModule,
		NzDrawerModule,
		NzTimePickerModule,
		NzSubmenuNoneInlineChildComponent,
		NzAlertModule,
		MonacoEditorModule.forRoot(),
		EmailBodyEditorComponent,
		NzListModule,
		NzSpinModule,
		NzAvatarModule,
		NzSpaceComponent,
		DragDropModule,
		NgbPopoverModule,
		NzFloatButtonModule,
		NzCommentModule,
		NzTreeModule,
		NzTreeSelectModule
	],
	providers: [
		provideClientHydration(),
		{ provide: NZ_I18N, useValue: en_US },
		provideAnimations(),
		provideAnimationsAsync(),
		provideHttpClient(withInterceptorsFromDi()),
		provideHighcharts()
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(library: FaIconLibrary) {
		library.addIconPacks(fas);
	}
}
